import { VCORE_API_KEY } from 'config';
import { AnySrvRecord } from 'dns';
import { Block, BlockVideo, LanguageCode, Variation, VariationInfo } from '@visikon/core-models/content';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { removeDelimitingCharacters } from './string';
import { Content } from '@visikon/core-models';
import { CompositionBlock } from '@visikon/core-models/models/composer/blocks';

export const NEW_RESOURCE_ID = 'new';
export const PLACEHOLDER_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA8AAAAMcAQMAAACl5F6MAAAABlBMVEW8vsDn6OnyCdevAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEbUlEQVR4AezBMQEAAADCoPVP7WsIoAcAAAAAAAAAAAAAAAAAAAAAAIydO0iOk4eCAGyVXNEuukF0FB1NHE1H0RG0ZEHRf5A99WYMk1T+Kvolw+vVjBf+CkMLoRCFWQkuqCquB3QOOQKrCpwBKJ1i6Jxk/EzTubaArgAHQOeyjhu8aMEafUrYolLjLRMfLrpw5cMYadeBnTLcrwN7ZXi+DhyuCi8GG/xy8Gyw3SRe7n7cLzfnajah5z87keFJ//lYf0WAAq+vv+rDX+fir+zpr2Xqr95qrle/ywr9OxX+/nF19fGRmR/yrzCJCudRqNHiNDHhIlquTBgCF2aX3V2BwYT9nUYdNoNojnqjiKJ56q0xiRaok4EsWqQO2EW0RJ3wQbTMvDc6iFaYswEvkx5Hnf8E0Tx1xhcfj3gh1lhOLHVWnx8vLvBq/FAnYpGBhwEElVfjhyETjVjj5bFanATpLrHIcpDkIstpJRdZLmRykaW63CLLMZKLLGeVXGS5jvlFluZKq8k1lnGMXGMZuck1lnsVu8ZydybXWOYj5BrLDIxcY5lz8mrML/JupPIC02osf3tyjeVqY9dYikys8QlTAUIsFovFYrFYLJaIP8hq8D4GG2ywwQYbbLDBBhtssMEGG2ywwQYb3N9+G/ePwQYbbLDBBhtssMEGG5yhA3ugqcARmFXgDKwqcAGgAsu+J1zYy94UXDjIRxosH+crwUm2euHCWX43Fy7YciUYI9N1YIeRavDpsMdIM9jgs+BOh4PBavA3ras6aMFRC06TEpyrLsy/H5emBKOrwvxZpsOsA3ssOk8SQQ9edZ4WI6DzfJwU4Ym/FCE7ofFXfQoJlnUugRsHdl9GTKBzlxRF6vzVW9kngr5eLTB5hT6MUhPgLfdDRhwQCQ79TQXe756tAWcp10XgIuMYF8aWxoedLtz5sB/wzIeDLrzw4QiRqHBSgOvnwLWFCrc7eCLCbnwrXFh2ZMdHKhEOyx3ciHBch8OHE2TtCZ0IZ0wCz1S4jhGTDhc0ecN9IcLja/qEVwIswqwC+/H3zfgMDw7j95cbPBFg+YEKnIaGWyoNzpvmcEujws0rwGX7LnCnwWOgDLhlZsFuaJEP+zFCC7yw4DCAhFtWFhwHl/lwwpeowRMJzlpw+QpXEgwl2O3gxoH9Du4cOOzgmQNHLTjt4OXF4byDVw5csAsHhhLssM/EgD32qQw4aMER+zQtuDPgpAVn7DMz4IJ9FgYMJdgdwSsB9jgKAQ5acDyEJy24ng8nLTgfwu18uBzC/XwYSrA7hmfCeyCHWU6Hw18Gr4R3fY5zOpy04PwEngj/KfYw9WwYSrB7BjfCW4qH6a8Kh2fwTHgF9jDLyXDSgvMzeKW8UX6Uk2Eowe45PL0m7J/D9VQ4aMG/isH/JwYbbLDBBhtssMEGG2ywtz3K/2tvDmQAAAAABvlbn+NbCSQWi8VisVgsFovFYrFYLBYvAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEHVJjR5bJLd8AAAAASUVORK5CYII=';
export const PLACEHOLDER_VIDEO =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA8AAAAMcAQMAAACl5F6MAAAABlBMVEW8vsDn6OnyCdevAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+IFHwk6LThlYRMAAALmSURBVHja7d1LjtpAGIVRLA889BJqKbU0szSWQpRBhukhA4TzUD/AEQip7bpJdM4MCemjy48e1V+7HQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABbm+85Xn+rzPN+3e54N3xe/LyXdcP1bvj6Txx+frw0WumbtS6LH/J5/YPw1dpOvz4f1gwPD8Lnxbq8tLm3ri9q9/vzqdG9Nc+LdTmvGZ4ehfe363JpdFNf3U1lsQKf1z0MHxcXZN/mabq6jafFCmwdPi0uyLHNY/xxG3d/vlG2fIw/wv364fIwfFmsy6lVeF6sy7nRi+s9XJqH97ffujR6Y76Hp1R4bh4+LN6rjf5HvIX7VHhoHz4uXm/7tuGSCtf1w91T4SkVnkPhLhXuU+EhFR5T4ZIK11R4SoXnULhLhftUeEiFx1S4pMI1FZ5S4TkU7lLhPhUeUuExFS6pcE2Fp1R4DoW7VLhPhYdUeEyFSypcU+EpFZ5D4S4V7lPhIRUeU+GSCtdUeEqF51D4Syr8NRX+lgp/T4VnYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFh4X80HNuSEtuEE9t2FNtoFdtalttMV1PhkgrHtojGNsXGtgHHNj7HtnrnNrfXVLikwrGRDbEhFbGxHLFBJLHRK7lhMzUVLqlwbIRSbGhUbExWbDBYbBRabvhbTYVLKhwbaRgb4hgbWxkb1BkbTZobxlpT4ZIKx0YMx4Yqx8ZIxwZnx0aF54aj1/XDf/kA/MDI/8Pu9kHetQ1vcazD9Ey4ax/e367L/3BYSX0qXJuHX7/19iCveCBNeSo8tg5veOjQ+FS4Xz8cO1jqcXjDo7Rih4fFjkuLHRCXOxKvPvH+2OQQwNixh7GDHmNHW+6eualfb+tVu7njS2MHtt5/kg+L37cDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICFH7ROXbVRVeDHAAAAAElFTkSuQmCC';
export const ERROR_IMAGE =
  'data:image/png;base64,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';

const grey = [
  '#fafafa 100%',
  'whitesmoke 98%',
  '#f0f0f0 96%',
  '#ebebeb 94%',
  '#e6e6e6 92%',
  '#e0e0e0 90%',
  '#dbdbdb 88%',
  '#d6d6d6 86%',
  '#d1d1d1 84%',
  '#cccccc 82%',
  '#c7c7c7 80%',
  '#c2c2c2 78%',
  '#bdbdbd 76%',
  '#b8b8b8 74%',
  '#b3b3b3 72%',
  '#adadad 70%',
  '#a8a8a8 68%',
  '#a3a3a3 66%',
  '#9e9e9e 64%',
  '#999999 62%',
  '#949494 60%',
  '#8f8f8f 58%',
  '#8a8a8a 56%',
  '#858585 54%',
  'gray 52%',
  '#7a7a7a 50%',
  '#757575 48%',
  '#707070 46%',
  '#6b6b6b 44%',
  '#666666 42%',
  '#616161 40%',
  '#5c5c5c 38%',
  '#575757 36%',
  '#525252 34%',
  '#4d4d4d 32%',
  '#474747 30%',
  '#424242 28%',
  '#3d3d3d 26%',
  '#383838 24%',
  '#333333 22%',
  '#2e2e2e 20%',
  '#292929 18%',
  '#242424 16%',
  '#1f1f1f 14%',
  '#1a1a1a 12%',
  '#141414 10%',
  '#0f0f0f 8%',
  '#0a0a0a 6%',
  '#050505 4%',
  'black 2%',
];

const NEW_DOCUMENT_TEXTS: [Content.LanguageCode, string][] = [
  ['da', 'Nyt dokument'],
  ['en', 'New document'],
  ['de', 'Neues dokument'],
  ['fr', 'Nouveau document'],
  ['es', 'Nuevo documento'],
  ['hi', 'नया दस्तावेज़'],
  ['sv', 'Nytt dokument'],
  ['no', 'Nytt dokument'],
  ['my', 'စာရွက်စာတမ်းအသစ်'],
  ['pt', 'Novo documento'],
];

export const getNewDocumentText = (language: Content.LanguageCode): string => {
  const found = NEW_DOCUMENT_TEXTS.find((tuple) => tuple[0] === language);
  return found ? found[1] : NEW_DOCUMENT_TEXTS[0][1];
};

export const fiftyShadesOfGrey = (n: number): string => {
  const index = n % grey.length;
  return grey[index];
};

export const emptySlateDocument = (language: Content.LanguageCode): any => {
  const translatedText = getNewDocumentText(language);
  return {
    object: 'value',
    document: {
      object: 'document',
      nodes: [
        {
          object: 'block',
          type: 'title',
          isVoid: false,
          nodes: [{ object: 'text', leaves: [{ object: 'leaf', text: translatedText, marks: [] }] }],
        },
        {
          object: 'block',
          type: 'paragraph',
          isVoid: false,
          nodes: [{ object: 'text', leaves: [{ object: 'leaf', text: '...', marks: [] }] }],
        },
      ],
    },
  };
};

export function genRange(length: number, offset?: number) {
  return Array(length)
    .fill(undefined)
    .map((_: undefined, idx: number) => idx + (offset || 0));
}

export function destroyVideoPlayer(videoElement: HTMLVideoElement) {
  try {
    videoElement.pause();
    videoElement.removeAttribute('src'); // empty source
    videoElement.load();
  } catch (e) {
    /* silent */
  }
}

export function createUniqueKey() {
  const ts = new Date().toISOString().replace(/[-:,.ZT]/g, '');
  const uuid = crypto.randomUUID();
  return `${ts}_${uuid}`;
}

export class ArrayUtils {
  static arrayMove<T>(arr: T[], from: number, to: number) {
    const copy = Object.assign([], arr);
    if (to >= copy.length) {
      let k = to - copy.length;
      while (k-- + 1) {
        // Skip
      }
    }
    copy.splice(to, 0, copy.splice(from, 1)[0]);
    return copy;
  }

  static chunkify<T>(array: T[], size?: number) {
    const chunks: T[][] = [];
    let i: number;
    let j: number;
    const chunk = size || 10;
    for (i = 0, j = array.length; i < j; i += chunk) {
      chunks.push(array.slice(i, i + chunk));
    }
    return chunks;
  }

  static replaceAtIndex<T>(array: T[], index: number, newObject: T): T[] {
    if (index < 0 || index >= array.length) {
      // eslint-disable-next-line no-console
      console.warn('replaceAtIndex called with index out of bounds');
      return array;
    }
    const part1 = array.slice(0, index);
    const part2 = array.slice(index + 1);
    return [...part1, newObject, ...part2];
  }
}

export class StringUtils {
  static capitalizeFirstLetter(str: string) {
    const s = str || '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  static getDateString() {
    return new Date().toISOString().slice(0, 10);
  }

  static zeroPad(n: number): string {
    if (n >= 0 && n < 10) {
      return `0${n}`;
    }
    return `${n}`;
  }

  static getFormattedTime() {
    const today = new Date();
    const y = today.getFullYear();
    // JavaScript months are 0-based.
    const m = today.getMonth() + 1;
    const d = today.getDate();
    const h = today.getHours();
    const mi = today.getMinutes();
    const s = today.getSeconds();
    return `${y}-${this.zeroPad(m)}-${this.zeroPad(d)}-${this.zeroPad(h)}-${this.zeroPad(mi)}-${this.zeroPad(s)}`;
  }

  static downloadTextFile(filename: string, text: string) {
    const element = document.createElement('a');
    element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}

export class APIUtils {
  static tokenHeader(token: string, otherHeaders?: object) {
    return {
      headers: {
        ...otherHeaders,
        Authorization: `Bearer ${token}`,
        'VCORE-API-KEY': VCORE_API_KEY,
      },
    };
  }

  static apiKeyHeader(otherHeaders?: object) {
    return {
      headers: {
        ...otherHeaders,
        'VCORE-API-KEY': VCORE_API_KEY,
      },
    };
  }

  static addParams = (urlPrefix: string, params: any): string => {
    let url = urlPrefix;
    if (!params) {
      return url;
    }
    const notNullParams = Object.entries(params).filter(([key, value]) => key && value && value !== '');
    if (notNullParams.length === 0) {
      return url;
    }
    url += '?';

    url += notNullParams.map(([key, value]) => `${key}=${value}`).join('&');
    return url;
  };
}

export class ContentUtils {
  static hasTranslation(content: { translations: Array<{ language: LanguageCode }> }, language: LanguageCode): boolean {
    for (const t of content.translations) {
      if (t.language === language) {
        return true;
      }
    }
    return false;
  }

  static isEmpty(content: { translations: any[] }) {
    return content.translations.length === 0;
  }

  static compareTags(tags: string[], filters: string[], allMatch: boolean) {
    // should compare use AND or OR
    const compare = allMatch ? (a: boolean, b: boolean) => a && b : (a: boolean, b: boolean) => a || b;
    // Initial depend on AND or OR
    const initial = allMatch;
    const filtersFound = filters.map((f) => tags.indexOf(f) !== -1);
    return filtersFound.reduce((acc, curr) => compare(acc, curr), initial);
  }

  static matchTags(filters: string[]) {
    return (somwthingTags: any) => {
      const tagsLowerCase = somwthingTags.tags.map((t: string) => t.toLowerCase());
      return filters.reduce((acc, term) => acc && tagsLowerCase.indexOf(term) !== -1, true);
    };
  }
}

function escapeRegExp(s: any) {
  return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function createSearchRegexp(query: string) {
  const words = query
    .split(/\s+/g)
    .map((s: any) => s.trim())
    .filter((s: AnySrvRecord) => !!s);
  const hasTrailingSpace = query.endsWith(' ');

  return new RegExp(
    `${words
      .map((word: any, i: any) => {
        if (i + 1 === words.length && !hasTrailingSpace) {
          // The last word - ok with the word being "startswith"-like
          return `(?=.*\\b${escapeRegExp(word)})`;
        }
        // Not the last word - expect the whole word exactly
        return `(?=.*\\b${escapeRegExp(word)}\\b)`;
      })
      .join('')}+`,
    'gi',
  );
}

function filterByName(item: any, regExp: RegExp) {
  switch (item.typeDescriptor) {
    case 'document':
      return regExp.test(item.documentName);
    case 'faq':
      return regExp.test(item.title);
    case 'symptom':
      return regExp.test(item.title);
    case 'notifications':
      return regExp.test(item.notificationListName);
    default:
      break;
  }

  return regExp.test(item.name);
}

function filterByManuscripts(item: any, regExp: RegExp) {
  if (!item.speaks) {
    return false;
  }

  const matches = item.speaks.filter((speak: any) => regExp.test(speak.text));
  return matches.length > 0;
}

function filterByTags(item: any, regExp: RegExp) {
  if (!item.tags) {
    return false;
  }

  const matches = item.tags.filter((tag: string) => regExp.test(tag));
  return matches.length > 0;
}

export function filterListsByName(q: any, list: any) {
  const searchRegex = createSearchRegexp(q);
  return list.filter((item: any) => filterByName(item, searchRegex));
}

function filterBy(fieldName: string, item: any, regExp: RegExp) {
  if (!item[fieldName]) {
    return false;
  }

  return regExp.test(item[fieldName]);
}

export type FilterCategory = 'name' | 'tags' | 'manuscripts' | 'department' | 'organization' | 'title' | 'description' | 'all';

export function filterListBy(category: FilterCategory, unfilteredList: any, query?: string) {
  if (!query || query.length === 0) return unfilteredList;

  const searchRegex = createSearchRegexp(query);
  return unfilteredList.filter((item: any) => {
    switch (category) {
      case 'name':
        return filterByName(item, searchRegex);
      case 'tags':
        return filterByTags(item, searchRegex);
      case 'manuscripts':
        return filterByManuscripts(item, searchRegex);
      case 'department':
      case 'organization':
      case 'title':
      case 'description':
        return filterBy(category, item, searchRegex);
      default:
        return (
          filterByName(item, searchRegex) ||
          filterByTags(item, searchRegex) ||
          filterByManuscripts(item, searchRegex) ||
          filterBy('department', item, searchRegex) ||
          filterBy('organization', item, searchRegex) ||
          filterBy('title', item, searchRegex) ||
          filterBy('description', item, searchRegex)
        );
    }
  });
}

// tslint:disable:no-any
interface ISomethingWithATranslation {
  [key: string]: any;

  translations: Array<{
    language: LanguageCode;
    [key: string]: any;
  }>;
}

export function replaceTranslation<A>(obj: A & ISomethingWithATranslation, newTranslation: any, language: LanguageCode): A {
  const copy = { ...obj };
  const otherTranslations = copy.translations.filter((t) => t.language !== language);
  copy.translations = Array.from([...otherTranslations, newTranslation]);
  return copy;
}

export interface BlockVideoScore {
  key: string;
  score: number;
}

export interface BlockVariantFilterResult {
  list: BlockVideoScore[];
  unique?: BlockVideo;
  ambigious?: BlockVideo[];
}

export class BlockUtils {
  static addVariationToVariationStat(acc: VariationInfo[], variation: Variation): VariationInfo[] {
    const idx = acc.findIndex((v) => v.value === variation);
    if (idx === -1) {
      // Add new entry
      return [
        ...acc,
        {
          value: variation,
          synonyms: [],
          count: 1,
        },
      ];
    }
    // Update existing entry
    return ArrayUtils.replaceAtIndex(acc, idx, {
      ...acc[idx],
      count: acc[idx].count + 1,
    });
  }

  static gatherVariations(blockList: CompositionBlock[], blocks: Block[], excludeUnambiguous?: boolean): VariationInfo[] {
    const fromVideo = blockList
      .map((bl) => blocks.find((b) => b._id === bl.blockId))
      .filter((b) => b !== undefined) // Map and resolve to Block[]
      .reduce((acc, b) => {
        if (excludeUnambiguous === true && b!.videos.length < 2) {
          return acc;
        }
        return acc.concat(b!.videos);
      }, [] as BlockVideo[]) // Reduce to BlockVideo[]
      .reduce((acc, vid) => acc.concat(vid.variations), [] as string[]); // Reduce to raw Variation[]

    const fromSpeak = blockList
      .map((bl) => blocks.find((b) => b._id === bl.blockId))
      .filter((b) => b !== undefined)
      .reduce((acc, b) => {
        if (excludeUnambiguous === true && b!.speaks.length < 2) {
          return acc;
        }
        return acc.concat(b!.speaks);
      }, [] as BlockVideo[]) // Reduce to BlockVideo[]
      // .reduce((acc, b) => acc.concat(b!.speaks), [] as BlockVideo[])
      .reduce((acc, vid) => acc.concat(vid.variations), [] as string[]);

    return [...fromVideo, ...fromSpeak].reduce(BlockUtils.addVariationToVariationStat, []);
  }


  static pickVariant(block: Block, variationFilter: string[]): BlockVariantFilterResult {
    return {
      list: [],
    };
  }
}

export function usePrevious<T>(value: T, noUpdateOnEqualValue: boolean = false): T | undefined {
  const ref = useRef<T>();

  useEffect(() => {
    if (noUpdateOnEqualValue && ref.current === value) return;

    ref.current = value;
  }, [value, noUpdateOnEqualValue]);

  return ref.current;
}

function createHiddenInput() {
  const element = document.createElement('input');
  element.style.display = 'none';
  document.body.appendChild(element);

  return element;
}

export async function copyToClipboard(text: string) {
  if (!text) {
    throw new Error('No text to copy.');
  }

  try {
    await navigator.clipboard.writeText(text);
  } catch (e) {
    const input = createHiddenInput();

    // Try input method
    input.value = text;
    input.focus();
    input.select();

    const result = document.execCommand('copy');
    input.remove();
    if (!result) {
      throw new Error(`Couldn't copy text.`);
    }
  }
}

export class DataRowExporter {
  public includeSeperatorMetadata = false;

  constructor(public readonly dataRows: string[][]) { }

  /**
   * Downloads current datarow as an tsv file
   *
   * @param filename the finale name for the tab seperated file without .tsv extension
   */
  public DownloadAsTsv(filename: string) {
    const blob = this.createValueSeperatedBlob('\t', 'text/tab-separated-values;charset=utf-16le');

    DownloadBlob(blob, `${filename}.tsv`);
  }

  /**
   * Downloads current datarow as an csv file
   *
   * @param filename the finale name of the file to be downloaded without the .csv extension
   */
  public DownloadAsCsv(filename: string, delimiter = ',') {
    // Creating blob and setting it to cvs
    const blob = this.createValueSeperatedBlob(delimiter, 'text/csv;charset=utf-16le');

    DownloadBlob(blob, `${filename}.csv`);
  }

  public createValueSeperatedBlob(seperator = ',', blobType?: string): Blob {
    const lines = this.dataRows.map((fields) => fields.map(removeDelimitingCharacters).join(seperator));

    if (this.includeSeperatorMetadata) {
      lines.unshift(`sep=${seperator}`);
    }

    const text = `${lines.join('\r\n')}\r\n`;

    // Always emit UTF-16 LE with a BOM (FF FE). Excel needs the BOM to correctly
    // detect both the encoding (so Danish characters render) and the tab/comma
    // separator. A UTF-8 BOM breaks Excel's separator auto-detection for .tsv,
    // so UTF-16 LE is the reliable choice.
    const buf = new Uint8Array(2 + text.length * 2);
    buf[0] = 0xff;
    buf[1] = 0xfe;
    for (let i = 0; i < text.length; i += 1) {
      const code = text.charCodeAt(i);
      // eslint-disable-next-line no-bitwise
      buf[2 + i * 2] = code & 0xff;
      // eslint-disable-next-line no-bitwise
      buf[3 + i * 2] = (code >> 8) & 0xff;
    }
    return new Blob([buf], { type: blobType });
  }
}

export function DownloadBlob(blob: Blob, filename: string) {
  // Creating an object for downloading url
  const url = window.URL.createObjectURL(blob);

  // Creating an anchor(a) tag of HTML
  const a = document.createElement('a');

  // Passing the blob downloading url
  a.setAttribute('href', url);

  // Setting the anchor tag attribute for downloading
  a.setAttribute('download', filename);

  // Performing a download with click
  a.click();
}

export const useLocalStorageState = <T>(key: string, initialState: T) => {
  const localStorageKey = `LOCALSTORAGE_${key.toUpperCase()}`;
  const [value, setValue] = useState<T>(initialState);

  useEffect(() => {
    const storedVal = localStorage.getItem(localStorageKey);
    if (storedVal) {
      const parsedVal = JSON.parse(storedVal);
      setValue(parsedVal);
    }
  }, [localStorageKey]);

  useEffect(() => {
    localStorage.setItem(localStorageKey, JSON.stringify(value));
  }, [value, localStorageKey]);

  return { value, setValue };
};

type QueryStateTypeOfs = 'string' | 'number' | 'boolean' | 'bigint';
type QueryStateType = string | number | boolean | bigint;
function getQueryParam<T extends QueryStateType>(search: string, key: string, type: QueryStateTypeOfs): T | null {
  const params = new URLSearchParams(search);
  const paramValue = params.get(key);

  if (paramValue === null) return null;

  switch (type) {
    case 'number':
      return Number(paramValue) as T;
    case 'boolean':
      return (paramValue === 'true') as T;
    case 'bigint':
      return BigInt(paramValue) as T;
    case 'string':
    default:
      return paramValue as T;
  }
}

function isQueryStateType(type: any): type is 'string' | 'number' | 'boolean' | 'bigint' {
  return ['string', 'number', 'boolean', 'bigint'].includes(type);
}

export interface QueryStateOptions {
  debounceTime?: number;
}

export function useQueryState<T extends QueryStateType>(key: string, initialState: T): [T, (newValue: T) => void] {
  const { location: { search }, replace: replaceHistory } = useHistory();

  const value = useMemo<T>(() => {
    const initalStateType = typeof initialState;
    if (!isQueryStateType(initalStateType)) return initialState;

    const queryValue = getQueryParam<T>(search, key, initalStateType);
    return queryValue === null ? initialState : queryValue as T;
  }, [initialState, key, search]);


  const setValue = useCallback((newValue: T) => {
    const params = new URLSearchParams(window.location.search);
    const oldValue = params.get(key);
    const newValueStr = newValue.toString();
    if (newValue == null || newValueStr === '') {
      params.delete(key);
    } else {
      params.set(key, newValueStr);
    }

    const newSearch = params.toString();

    if (newValueStr === oldValue) return;
    replaceHistory({
      ...location,
      search: `?${newSearch}`,
    })
  }, [key, replaceHistory])

  return [value, setValue];
}


export function useDebounce<T>(value: T, debounceMs: number = 500): T {
  const [internalValue, setInternalValue] = useState<T>(value);

  useEffect(() => {
    const timeoutHandle = window.setTimeout(() => {
      setInternalValue(value)
    }, debounceMs);

    return () => {
      window.clearTimeout(timeoutHandle);
    }
  }, [value, debounceMs]);

  return debounceMs <= 0 ? value : internalValue;
}

/** Returns whether the CSS media query currently matches, updating when the window changes. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const handleChange = () => setMatches(mediaQueryList.matches);

    // Sync in case the query changed or the window was resized before the listener was attached
    handleChange();
    mediaQueryList.addEventListener('change', handleChange);

    return () => {
      mediaQueryList.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
}

type DistributiveOmit<T, K extends PropertyKey> = T extends unknown ? Omit<T, K> : never;

export function ObjectOmit<T extends object, K extends keyof T>(obj: T, ...keys: K[]): DistributiveOmit<T, K>;
export function ObjectOmit<T extends object, K extends keyof T>(obj: T, ...keys: K[]): Omit<T, K> {
  const clone = { ...obj };
  for (const key of keys) {
    delete clone[key];
  }

  return clone;
}
